function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { dedupingMixin } from '@polymer/polymer/lib/utils/mixin.js';
/**
 * A mixin to delegate properties and attributes to a target element.
 *
 * @polymerMixin
 */

export var DelegateStateMixin = dedupingMixin(function (superclass) {
  return /*#__PURE__*/function (_superclass) {
    _inherits(DelegateStateMixinClass, _superclass);

    var _super = _createSuper(DelegateStateMixinClass);

    function DelegateStateMixinClass() {
      _classCallCheck(this, DelegateStateMixinClass);

      return _super.apply(this, arguments);
    }

    _createClass(DelegateStateMixinClass, [{
      key: "ready",
      value:
      /** @protected */
      function ready() {
        _get(_getPrototypeOf(DelegateStateMixinClass.prototype), "ready", this).call(this);

        this._createDelegateAttrsObserver();

        this._createDelegatePropsObserver();
      }
      /** @protected */

    }, {
      key: "_stateTargetChanged",
      value: function _stateTargetChanged(target) {
        if (target) {
          this._ensureAttrsDelegated();

          this._ensurePropsDelegated();
        }
      }
      /** @protected */

    }, {
      key: "_createDelegateAttrsObserver",
      value: function _createDelegateAttrsObserver() {
        this._createMethodObserver("_delegateAttrsChanged(".concat(this.constructor.delegateAttrs.join(', '), ")"));
      }
      /** @protected */

    }, {
      key: "_createDelegatePropsObserver",
      value: function _createDelegatePropsObserver() {
        this._createMethodObserver("_delegatePropsChanged(".concat(this.constructor.delegateProps.join(', '), ")"));
      }
      /** @protected */

    }, {
      key: "_ensureAttrsDelegated",
      value: function _ensureAttrsDelegated() {
        var _this = this;

        this.constructor.delegateAttrs.forEach(function (name) {
          _this._delegateAttribute(name, _this[name]);
        });
      }
      /** @protected */

    }, {
      key: "_ensurePropsDelegated",
      value: function _ensurePropsDelegated() {
        var _this2 = this;

        this.constructor.delegateProps.forEach(function (name) {
          _this2._delegateProperty(name, _this2[name]);
        });
      }
      /** @protected */

    }, {
      key: "_delegateAttrsChanged",
      value: function _delegateAttrsChanged() {
        var _this3 = this;

        for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
          values[_key] = arguments[_key];
        }

        this.constructor.delegateAttrs.forEach(function (name, index) {
          _this3._delegateAttribute(name, values[index]);
        });
      }
      /** @protected */

    }, {
      key: "_delegatePropsChanged",
      value: function _delegatePropsChanged() {
        var _this4 = this;

        for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          values[_key2] = arguments[_key2];
        }

        this.constructor.delegateProps.forEach(function (name, index) {
          _this4._delegateProperty(name, values[index]);
        });
      }
      /** @protected */

    }, {
      key: "_delegateAttribute",
      value: function _delegateAttribute(name, value) {
        if (!this.stateTarget) {
          return;
        }

        if (name === 'invalid') {
          this._delegateAttribute('aria-invalid', value ? 'true' : false);
        }

        if (typeof value === 'boolean') {
          this.stateTarget.toggleAttribute(name, value);
        } else if (value) {
          this.stateTarget.setAttribute(name, value);
        } else {
          this.stateTarget.removeAttribute(name);
        }
      }
      /** @protected */

    }, {
      key: "_delegateProperty",
      value: function _delegateProperty(name, value) {
        if (!this.stateTarget) {
          return;
        }

        this.stateTarget[name] = value;
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * A target element to which attributes and properties are delegated.
           * @protected
           */
          stateTarget: {
            type: Object,
            observer: '_stateTargetChanged'
          }
        };
      }
      /**
       * An array of the host attributes to delegate to the target element.
       */

    }, {
      key: "delegateAttrs",
      get: function get() {
        return [];
      }
      /**
       * An array of the host properties to delegate to the target element.
       */

    }, {
      key: "delegateProps",
      get: function get() {
        return [];
      }
    }]);

    return DelegateStateMixinClass;
  }(superclass);
});